import { GridSize } from '@material-ui/core/es/Grid';

export const isUserColumnMdSize = (clientWidth: number): boolean => {
  return clientWidth < 1440;
};

export const subscriptionColumnSize = (clientWidth: number): GridSize => {
  return clientWidth < 1440 ? 9 : 6;
};
